mutation TerminateProductPurchase($id: ID!) {
  terminateProductPurchase(id: $id) {
    id
    startAt
    expiredAt
  }
}
